import React, { useEffect } from "react";
import Navbar from "../components/public/Navbar";
import Hero from "../components/public/Hero";
import About from "../components/public/About";
import CreditResources from "../components/public/CreditResources";
import Services from "../components/public/Services";
import BooksTeaser from "../components/public/BooksTeaser";
import Financing from "../components/public/Financing";
import LegacyPillars from "../components/public/LegacyPillars";
import Testimonials from "../components/public/Testimonials";
import Contact from "../components/public/Contact";
import Footer from "../components/public/Footer";
import CookieBanner from "../components/public/CookieBanner";
import StickyBookButton from "../components/public/StickyBookButton";

export default function PublicSite() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const els = document.querySelectorAll(".reveal");
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-visible");
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => obs.observe(el));

    if (!window.__denefitsLoaded) {
      window.__denefitsLoaded = true;
      const script = document.createElement("script");
      script.src = "https://assets.denefits.com/denefits-lead-gen.min.js";
      script.async = true;
      document.body.appendChild(script);
    }

    return () => obs.disconnect();
  }, []);

  const scrollToContact = () =>
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="bg-white">
      <Navbar />
      <Hero onBook={scrollToContact} />
      <About />
      <CreditResources />
      <Services />
      <BooksTeaser />
      <Financing />
      <LegacyPillars />
      <Testimonials />
      <Contact />
      <Footer />
      <CookieBanner />
      <StickyBookButton onBook={scrollToContact} />
    </div>
  );
}
